import { render, staticRenderFns } from "./AwardTable.vue?vue&type=template&id=2d08c300&scoped=true&"
import script from "./AwardTable.vue?vue&type=script&lang=js&"
export * from "./AwardTable.vue?vue&type=script&lang=js&"
import style0 from "./AwardTable.vue?vue&type=style&index=0&id=2d08c300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08c300",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VChip,VIcon,VSimpleTable})
